import { ClockIcon } from '@heroicons/react/24/outline';
import { addDays } from 'date-fns';
import * as React from 'react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

interface SnoozeButtonProps {
  currentDueDate?: string | null;
  onDueDateChange: (date: Date | null) => void;
  className?: string;
  size?: 'sm' | 'default';
}

export const SnoozeButton: React.FC<SnoozeButtonProps> = ({
  currentDueDate,
  onDueDateChange,
  className,
  size = 'sm',
}) => {
  const handleSnooze = (days: number) => {
    const baseDate = currentDueDate ? new Date(currentDueDate) : new Date();
    const newDate = addDays(baseDate, days);
    onDueDateChange(newDate);
  };

  const handleSnoozeClick = (days: number, event: React.MouseEvent) => {
    event.stopPropagation();
    handleSnooze(days);
  };

  const iconSize = size === 'sm' ? 'h-3 w-3' : 'h-4 w-4';
  const buttonSize = size === 'sm' ? 'h-6 w-6' : 'h-8 w-8';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            buttonSize,
            'p-0 text-slate-400 hover:text-slate-600 hover:bg-slate-100',
            className,
          )}
          title="Snooze task"
        >
          <ClockIcon className={iconSize} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem onClick={(e) => handleSnoozeClick(1, e)}>
          <span className="text-xs font-medium">+1 day</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleSnoozeClick(3, e)}>
          <span className="text-xs font-medium">+3 days</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={(e) => handleSnoozeClick(7, e)}>
          <span className="text-xs font-medium">+1 week</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
